import { Loader2 } from "lucide-react";
import { cn } from "../cn";

/* 1:1 with discordforge.org loading states (TeamModal.tsx):
 *   <Loader2 className="w-8 h-8 text-orange-400 animate-spin" /> */
export interface SpinnerProps {
    size?: number;
    className?: string;
    /** Show a label under the spinner */
    label?: string;
}

export function Spinner({ size = 24, className, label }: SpinnerProps) {
    return (
        <span className={cn("inline-flex flex-col items-center justify-center gap-3", className)}>
            <Loader2
                className="animate-spin text-orange-400"
                style={{ width: size, height: size }}
                aria-hidden
            />
            {label && (
                <span className="text-[10px] font-bold uppercase tracking-widest text-zinc-500">{label}</span>
            )}
        </span>
    );
}
